module.exports = __webpack_public_path__ + "assets/img/chatFirstStep.1173db37.png";